import { clearBookings } from '@/features/profile/profileActions';
import { withAuthGuard } from '@/hoc/withAuthGuard';
import { usePageTitle } from '@/hooks/usePageTitle';
import { useDispatch } from '@/store/utils';
import type { FC } from 'react';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

interface AccountProps {}

const AccountComponent: FC<AccountProps> = () => {
  const dispatch = useDispatch();

  usePageTitle('account');

  useEffect(() => {
    return () => {
      dispatch(clearBookings());
    };
  }, [dispatch]);

  return <Outlet />;
};

const Account = withAuthGuard('protected')(AccountComponent);

export default Account;
